import Vue from 'vue'
import { Button, Table, Form, Input, Tabs, Icon, message, Modal, Select, Divider, Tooltip, LocaleProvider } from 'ant-design-vue'
import { FlightCitySelector, Calendar } from 'ace-ui-eking'
import moment from 'moment'

import './index.less'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Table)
Vue.use(Form)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Select)
Vue.use(Calendar)
Vue.use(FlightCitySelector)
Vue.use(Divider)
Vue.use(Tooltip)
Vue.use(LocaleProvider)

Vue.prototype.$message = message
Vue.prototype.$error = Modal.error

Vue.filter('gtTime', (time) => {
  if (!time) return '-'
  // NOTE: 获取日期精确到天
  return moment(time).format('MM-DD/HH:mm') || ''
})

Vue.filter('gtLocal', (record) => {
  return record?.fltType === 'I' ? '[当地]' : ''
})
